import { useRecoilValue } from "recoil";
import { ActionsCell } from "../../../Component/Common/Components/DataTable/ActionsCell";
import { DefaultCell } from "../../../Component/Common/Components/DataTable/DefaultCell";
import { PlatformPeople } from "../../../Component/Model/Dto/Platform/PlatformPeople";
import { ActionType, TableColumn } from "../../../Component/Model/Table/Table";
import { userRolesState } from "../../../State/user.Atom";
import { PlatformPeopleEditRole, UserAdminRole } from "../../../Component/Common/Constants/UserRoles";
import { Attendee } from "./AttendeeDataTableColumns";
import { AttendeeDto } from "../../../Component/Model/Dto/WSP/Attendees/MerSETAAttendees";
import { CurrencyFormatter } from "../../../Helpers/CurrencyFormatter";

interface AttendeeRows {
    platformPeopleId: string,
    fullName: string,
    idNumber: string,
    employeeCode: string,
    jobTitle: string,
    stipendTotal?: string;
    actions?: ActionType[];
}

interface AttendeeTable {
    columns: Array<TableColumn>;
    rows: Array<AttendeeRows>;
}

export function AttendeeTableMapper(dataObject: AttendeeDto[], deleteAttendee: (personId: string, fullName: string) => void, showStipendsModal: (id: string, name: string) => void, isHEBursary?: boolean): AttendeeTable {

    const userRoles = useRecoilValue(userRolesState);
    function getActionsColumn(item: AttendeeDto, index: number) {
        const actions: ActionType[] = [
            isHEBursary
                ? {
                    key: index.toString(),
                    label: 'Capture Stipend',
                    action: () => {
                        showStipendsModal(item.platformPeopleId!, item.attendee!);
                    },
                    icon: {
                        color: 'info',
                        name: 'payment',
                    },
                }
                : null, {
                key: index.toString(),
                label: 'Delete',
                action: () => {
                    deleteAttendee(item.platformPeopleId!, item.attendee!);
                },
                icon: {
                    color: 'error',
                    name: 'delete',
                },
            },
        ].filter(Boolean) as ActionType[];

        return actions;
    }

    const columns = GetColumns(isHEBursary);

    if (dataObject !== undefined && dataObject.length > 0) {

        const rows = dataObject.map((item: AttendeeDto, index: number) => ({
            platformPeopleId: item.platformPeopleId!,
            fullName: item.attendee!,
            idNumber: item.idNumber,
            employeeCode: item.employeeCode,
            jobTitle: item.jobTitle!,
            stipendTotal: item.stipendTotal ? CurrencyFormatter(Number(item.stipendTotal)) : 'R 0',
            actions: getActionsColumn(item, index),
        }));
        return { columns: columns, rows: rows };
    }
    else {
        return { columns: columns, rows: [] };
    }
}

function GetColumns(isHeBursary?: boolean) {
    var result = [];
    if (isHeBursary) {
        result = [{ Header: 'Attendee', accessor: 'fullName', id: 'fullName', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'ID Number', accessor: 'idNumber', id: 'idNumber', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'Employee Code', accessor: 'employeeCode', id: 'employeeCode', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'Stipend', accessor: 'stipendTotal', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'Job Title', accessor: 'jobTitle', id: 'jobTitle', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'Actions', accessor: 'actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true },
        ];
    }
    else {
        result = [{ Header: 'Attendee', accessor: 'fullName', id: 'fullName', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'ID Number', accessor: 'idNumber', id: 'idNumber', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'Employee Code', accessor: 'employeeCode', id: 'employeeCode', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'Job Title', accessor: 'jobTitle', id: 'jobTitle', Cell: ({ value }: any) => <DefaultCell value={value}  />, disableSortBy: true },
        { Header: 'Actions', accessor: 'actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true }

        ];
    }
    return result;

}
